// ** React Imports
import { Link } from 'react-router-dom'
import { useWeb3React } from '@web3-react/core'
// import {  useEffect } from "react"

// ** Custom Components
import Avatar from '@components/avatar'
import EthFanLogo from '@src/assets/images/logo/ethfan-logo.png'

// ** Utils
// import { isUserLoggedIn } from '@utils'

// ** Third Party Components
import { Power } from 'react-feather'

// ** Reactstrap Imports
import { UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap'

const UserDropdown = () => {

  const { account, deactivate } = useWeb3React()

  const disconnect = () => {
    try {
      window.localStorage.removeItem("userData")
      deactivate()
    } catch (error) {
      console.error("error while logout from user ", error)
    }
  }

  const getTruncatedAddress = (address) => {
    if (address && address.startsWith("0x")) {
      return `${address.substr(0, 7)}...${address.substr(address.length - 7)}`
    }
    return address
  }

  return (
    <UncontrolledDropdown tag='li' className='dropdown-user nav-item'>
      <DropdownToggle href='/' tag='a' className='nav-link dropdown-user-link' onClick={e => e.preventDefault()}>
        <div className='user-nav d-sm-flex d-none'>
          <span className='user-name fw-bold'>{getTruncatedAddress(account)}</span>
          {/* <span className='user-status'>0.0000000009 USD</span> */}
        </div>
        <Avatar img={EthFanLogo} imgHeight='40' imgWidth='40' status='online' />
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem tag={Link} to="/" onClick={disconnect}>
          <Power size={14} className='me-75' />
          <span className='align-middle'>Disconnect</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}

export default UserDropdown
